import type { Option } from '@usealloy/component-library';
import { groupType } from 'flow/service/rules';

export const groupTypeOptions: Option[] = [
  {
    label: 'and',
    value: groupType.and,
  },
  {
    label: 'or',
    value: groupType.or,
  },
];
